// Suspense fallback for lazily-loaded route chunks (code-splitting). A quiet centered
// spinner — brief on any real connection, and the surrounding shell (header, breadcrumbs,
// tool tabs) stays put because the Suspense boundaries sit INSIDE the layouts.
export default function PageFallback() {
  return (
    <div
      role="status"
      aria-busy="true"
      aria-label="Loading"
      style={{ display: "flex", justifyContent: "center", alignItems: "center", minHeight: "40vh" }}
    >
      <span className="spinner" />
    </div>
  );
}
